// services/memoryService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
});

export const memoryService = {
  async getMemoryBySlug(slug) {
    try {
      const res = await api.get(`/api/v1/memory/${slug}`);
      return res.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        'Failed to load memory';
      const wrapped = new Error(message);
      wrapped.response = error.response;
      throw wrapped;
    }
  }
};

export default memoryService;